import React, { forwardRef } from "react";
import FilterWhiteIcon from "../../assets/images/icons/filter-white.svg";
import FilterPrimaryIcon from "../../assets/images/icons/filter-primary.svg";
import FilterDarkIcon from "../../assets/images/icons/filter-icon.svg";
import FilterDarkPrimaryIcon from "../../assets/images/icons/filter-icon-primary.svg";

export const isDateRangeFilterActive = (startDate, endDate) => Boolean(startDate && endDate);

const FilterTrigger = forwardRef(function FilterTrigger(
  {
    active = false,
    variant = "white",
    bordered = true,
    className = "",
    onClick,
    children,
    iconHeight = "20px",
    alt = "Filter",
  },
  ref
) {
  const inactiveIcon = variant === "icon" ? FilterDarkIcon : FilterWhiteIcon;
  const activeIcon = variant === "icon" ? FilterDarkPrimaryIcon : FilterPrimaryIcon;
  const iconSrc = active ? activeIcon : inactiveIcon;

  const classes = [
    bordered && "position-relative filter-trigger--bordered",
    bordered && active && "filter-trigger--active",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div ref={ref} className={classes || undefined} onClick={onClick} role="button">
      <img src={iconSrc} height={iconHeight} alt={alt} className="filter-trigger__icon" />
      {children}
    </div>
  );
});

export default FilterTrigger;
